import * as Joi from 'joi';

const completionOperatorSchema = Joi.object()
  .keys({
    name: Joi.string().required(),
    description: Joi.string().required(),
  })
  .required();

const completionItemSchema = Joi.object().keys({
  name: Joi.string().required(),
  description: Joi.string().required(),
});

const customCompletionSchema = Joi.object()
  .keys({
    provideCompletionItems: Joi.function().required(),
    validate: Joi.function().required(),
  })
  .required();

const modelSchemaFieldItemSchema = Joi.object()
  .keys({
    name: Joi.string().required(),
    description: Joi.string().required(),
    invalidMessage: Joi.string().required(),
    forceSelection: Joi.boolean().required(),
    needsBackendCompletion: Joi.boolean(),
    needsNumericBackendCompletion: Joi.boolean(),
    values: [Joi.array().items(completionItemSchema).required(), customCompletionSchema],
  })
  .required();

const modelSchemaFieldsOptionsSchema = Joi.object()
  .keys({
    forceSelection: Joi.bool().required(),
    invalidMessage: Joi.string().required(),
    items: Joi.array().items(modelSchemaFieldItemSchema).required(),
  })
  .default({
    forceSelection: false,
    invalidMessage: '',
    items: [],
  });

const modelSchemaTermsOptionsSchema = Joi.object()
  .keys({
    forceSelection: Joi.bool().required(),
    invalidMessage: Joi.string().required(),
    items: Joi.array().items(completionItemSchema).required(),
  })
  .default({
    forceSelection: false,
    invalidMessage: '',
    items: [],
  });

const modelSchemaOperatorsOptionsSchema = Joi.object()
  .keys({
    forceSelection: Joi.bool().required(),
    invalidMessage: Joi.string().required(),
    items: Joi.array().items(completionOperatorSchema).required(),
  })
  .default({
    forceSelection: false,
    invalidMessage: '',
    items: [],
  });

const modelSchemaOptionsSchema = Joi.object().keys({
  fields: modelSchemaFieldsOptionsSchema,
  terms: modelSchemaTermsOptionsSchema,
  operators: modelSchemaOperatorsOptionsSchema,
});

export const modelOptionsSchema = Joi.object()
  .keys({
    validate: Joi.bool().default(true),
    hover: Joi.bool().default(false),
    autoComplete: Joi.bool().default(false),
    schema: modelSchemaOptionsSchema,
  })
  .required();
